<template>
    <div>
        <div class="main-content">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Próximas viagens programadas
                                <span
                                    data-toggle="collapse"
                                    href="#"
                                    @click="getNextTrips"
                                    class="btn-filter"
                                    style="cursor: pointer"
                                >
                                    Atualizar
                                    <i class="fas fa-sync-alt"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-5 mt-3 justify-content-center">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="chartSpot">Cidade de Destino</label>
                                        <v-select
                                            :options="cityDestinations"
                                            label="description"
                                            :clearable="false"
                                            :reduce="(cityDestinations) => cityDestinations.id"
                                            class="style-chooser"
                                            placeholder="Selecione a cidade que você pretende visitar"
                                            v-model="filter.city_destination"
                                        >
                                            <div slot="no-options">Carregando...</div>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="chartDateStart">Data de Saída</label>
                                        <CtkDateTimePicker
                                            v-model="filter.retreat_date"
                                            :color="$store.state.date_picker_color"
                                            locale="pt-br"
                                            no-label
                                            only-date
                                            formatted="ll"
                                            button-now-translation="Hoje"
                                            class="datetimepicker"
                                            label="Selecione a data que você pretende viajar"
                                            format="YYYY-MM-DD"
                                            id="retreat_date"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="chartDateStart">Data de Retorno</label>
                                        <CtkDateTimePicker
                                            v-model="filter.devolution_date"
                                            :color="$store.state.date_picker_color"
                                            locale="pt-br"
                                            no-label
                                            only-date
                                            formatted="ll"
                                            button-now-translation="Hoje"
                                            class="datetimepicker"
                                            label="Selecione a data que você pretende retornar"
                                            format="YYYY-MM-DD"
                                            id="retreat_date"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-12 text-right">
                                    <button
                                        class="btn btn-default"
                                        @click="getNextTrips"
                                    >
                                        Buscar Viagens
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 table-responsive">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">ID Reserva</th>
                                            <th scope="col">Nome do Usuário</th>
                                            <th scope="col">Veículo</th>
                                            <th scope="col">Placa Veículo</th>
                                            <th scope="col">Data de Saída</th>
                                            <th scope="col">Data de Retorno</th>
                                            <th scope="col">Filial</th>
                                            <th scope="col">Cidade de Destino</th>
                                            <th scope="col">Vagas Disponíveis</th>
                                            <th scope="col">Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="trips.length > 0">
                                        <tr
                                            v-for="divergence in trips"
                                            :key="divergence.id"
                                        >
                                            <td>{{ divergence.reserve_id }}</td>
                                            <td>
                                                <div class="d-flex flex-row align-items-center justify-content-between">
                                                    <span>
                                                        {{ divergence.reserve.user.name }}
                                                    </span>
                                                    <button
                                                        class="btn btn-user h-10"
                                                        data-tooltip="tooltip"
                                                        title="Dados do Usuário"
                                                        data-dismiss="modal"
                                                        data-toggle="modal"
                                                        @click="openModalUser(divergence.reserve.user)"
                                                    >
                                                        <i class="fas fa-user"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td>{{ getVehicleDescription(divergence.reserve) }}</td>
                                            <td>{{ getVehicleBoard(divergence.reserve) }}</td>
                                            <td>{{ divergence.reserve.retreat_date }}</td>
                                            <td>{{ divergence.reserve.devolution_date }}</td>
                                            <td>{{ divergence.reserve.branch.description }}</td>
                                            <td>
                                                {{ divergence.city_destination.description }}
                                            </td>
                                            <td>
                                                {{ divergence.available_seats }}
                                            </td>
                                            <td>
                                                <button
                                                    v-if="checkAvailability(divergence)"
                                                    class="btn btn-default centered"
                                                    data-tooltip="tooltip"
                                                    title="Dados do Usuário"
                                                    data-dismiss="modal"
                                                    data-toggle="modal"
                                                    @click="openModalCarona(divergence)"
                                                >
                                                    <i class="fas fa-users mr-1"></i>
                                                    Pedir Carona
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="9"
                                                align="center"
                                            >
                                                Nenhuma viagem programada para a rota e/ou período
                                                informado
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="col-md-12"
                    v-if="receiveds.length > 0"
                >
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Pedidos de carona recebidos
                                <span
                                    data-toggle="collapse"
                                    href="#"
                                    @click="getNextTrips"
                                    class="btn-filter"
                                    style="cursor: pointer"
                                >
                                    Atualizar
                                    <i class="fas fa-sync-alt"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">Cidade de Destino</th>
                                            <th scope="col">Nome do Usuário</th>
                                            <th scope="col">Data de Saída</th>
                                            <th scope="col">Data de Retorno</th>
                                            <th scope="col">Mensagem</th>
                                            <th scope="col">Ações</th>
                                        </tr>
                                        </thead>
                                        <tbody v-if="receiveds.length > 0">
                                        <tr
                                            v-for="received in receiveds"
                                            :key="received.id"
                                        >
                                            <td>{{
                                                    received.city_destination ? received.city_destination.description : 'N/A'
                                                }}
                                            </td>
                                            <td>
                                                <div class="d-flex flex-row align-items-center justify-content-between">
                                                    {{ received.requester.name }}
                                                    <button
                                                        class="btn btn-user h-10"
                                                        data-tooltip="tooltip"
                                                        title="Dados do Usuário"
                                                        data-dismiss="modal"
                                                        data-toggle="modal"
                                                        @click="openModalUser(received.requester)"
                                                    >
                                                        <i class="fas fa-user"></i>
                                                    </button>
                                                </div>
                                            </td>
                                            <td>{{ received.reserve.retreat_date }}</td>
                                            <td>{{ received.reserve.devolution_date }}</td>
                                            <td>{{ received.requester_observation }}</td>
                                            <td v-if="received.status == 1">
                                                <button
                                                    class="btn btn-default"
                                                    @click="openModalApprove(received); modalResponsetRide = true;"
                                                >
                                                    Responder
                                                </button>
                                            </td>
                                            <td v-else>
                                                <h5 class="=my-auto">
                                                    <span
                                                        :class="
                                                            'badge badge-' +
                                                            (received.status == 1
                                                              ? 'warning'
                                                              : received.status == 2
                                                              ? 'success'
                                                              : 'danger')
                                                          "
                                                    >{{
                                                            received.status == 1
                                                                ? "Aguardando"
                                                                : received.status == 2
                                                                    ? "Aprovada"
                                                                    : "Rejeitada"
                                                     }}
                                                    </span
                                                    >
                                                </h5>
                                            </td>
                                        </tr>
                                        </tbody>
                                        <tbody v-else>
                                        <tr>
                                            <td
                                                colspan="9"
                                                align="center"
                                            >
                                                Nenhum registro encontrado.
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    class="col-md-12"
                    v-if="requesteds.length > 0"
                >
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Pedidos de carona que eu solicitei
                                <span
                                    data-toggle="collapse"
                                    href="#"
                                    @click="getNextTrips"
                                    class="btn-filter"
                                    style="cursor: pointer"
                                >
                                    Atualizar
                                    <i class="fas fa-sync-alt"></i>
                                </span>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>
                                            <th scope="col">Cidade de Destino</th>
                                            <th scope="col">Nome do Usuário</th>
                                            <th scope="col">Data de Saída</th>
                                            <th scope="col">Data de Retorno</th>
                                            <th scope="col">Mensagem</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr
                                            v-for="requested in requesteds"
                                            :key="requested.id"
                                        >
                                            <template
                                                v-if="requested.reserve && requested.requested"
                                            >


                                                <td>{{
                                                        requested.city_destination ? requested.city_destination.description : ''
                                                    }}
                                                </td>
                                                <td>
                                                    <div class="d-flex flex-row align-items-center justify-content-between">
                                                        {{ requested.requested.name }}
                                                        <button
                                                            class="btn btn-user h-10"
                                                            data-tooltip="tooltip"
                                                            title="Dados do Usuário"
                                                            data-dismiss="modal"
                                                            data-toggle="modal"
                                                            @click="openModalUser(requested.requested)"
                                                        >
                                                            <i class="fas fa-user"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td>{{ requested.reserve.retreat_date }}</td>
                                                <td>{{ requested.reserve.devolution_date }}</td>
                                                <td>{{ requested.requested_observation }}</td>
                                                <td>
                                                    <h5 class="my-auto">
                                                        <span
                                                            :class="
                                                            'badge badge-' +
                                                            (requested.status == 1
                                                              ? 'warning'
                                                              : requested.status == 2
                                                              ? 'success'
                                                              : 'danger')
                                                          "
                                                        >{{
                                                                requested.status == 1
                                                                    ? "Aguardando"
                                                                    : requested.status == 2
                                                                        ? "Aprovada"
                                                                        : "Rejeitada"
                                                         }}
                                                        </span
                                                        >
                                                    </h5>
                                                </td>

                                            </template>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading
            :active.sync="isLoading"
            :is-full-page="fullPage"
        ></loading>

        <user-modal
            :modalStatus="modalUserStatus"
            :dataModal="dataModalUser"
            @changeModal="changeUserModal"
            v-if="loadModalUser"
        ></user-modal>

        <RequestRideModal
            :divergence="dataRideModal"
            :modal-status="modalRequestRide"
            @close="modalRequestRide = false"
            @get-ride="getRide"
        />

        <ResponseRideModal
            :divergence="dataModalApprove"
            :modal-status="modalResponsetRide"
            @close="modalResponsetRide = false"
            @change-status="changeStatus"
        />
    </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {Pagination} from "vue-pagination-2";
import UserModal from "../Modals/UserModal";
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import {getMessage} from "../../composables/message";
import RequestRideModal from "../Modals/RequestRideModal.vue";
import ResponseRideModal from "../Modals/ResponseRideModal.vue";
import {shouldHideVehicleData} from "../../composables/useVehicleVisibility";

export default {
    data() {
        return {
            options: {
                texts: {
                    count: "Mostrando {from} de {to} até {count} de registros",
                },
                chunk: 4,
                chunksNavigation: "fixed",
            },
            isLoading: true,
            fullPage: true,
            trips: [],
            receiveds: [],
            requesteds: [],
            cityDestinations: [],
            modalUserStatus: false,
            modalRequestRide: false,
            modalResponsetRide: false,
            loadModalUser: false,
            dataModalUser: {},
            dataRideModal: {},
            dataModalApprove: {
                city_destination: {
                    description: ''
                }
            },
            filter: {},
            divergence: [],
        };
    },

    computed: {},
    methods: {
        getVehicleDescription(reserve) {
            const user = this.$store.state.user;
            if (!reserve || !reserve.vehicles) return 'N/A';
            if (shouldHideVehicleData(user, reserve)) {
                return 'Veículo Oculto';
            }
            return reserve.vehicles.description;
        },
        getVehicleBoard(reserve) {
            const user = this.$store.state.user;
            if (!reserve || !reserve.vehicles) return 'N/A';
            if (shouldHideVehicleData(user, reserve)) {
                return '***-***';
            }
            return reserve.vehicles.board;
        },
        checkAvailability(divergence) {
            let date = divergence.reserve.retreat_date;

            const [datePart, timePart] = date.split(" ");
            const [day, month, year] = datePart.split("/").map(Number);
            const [hours, minutes, seconds] = timePart.split(":").map(Number);

            const retreat = new Date(year, month - 1, day, hours, minutes, seconds);
            const now = new Date();
            const oneHourAhead = new Date(now.getTime() + 60 * 60 * 1000);

            const currentUser = this.$store.state.user;

            return (retreat > oneHourAhead) && (divergence.available_seats > 0) && (currentUser.id !== divergence.reserve.user.id) && !!divergence.reserve.shared_reservation;
        },
        getNextTrips: function () {
            const self = this;
            const api = self.$store.state.api + "next-trips";

            self.isLoading = true;

            self.$http
                .post(api, {filters: self.filter})
                .then((response) => {
                    self.trips = response.data.reserves;
                    self.receiveds = response.data.receiveds;
                    self.requesteds = response.data.requesteds;

                    self.isLoading = false;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getCityDestinations: function () {
            const self = this;
            const api = self.$store.state.api + "cityDestinations/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.cityDestinations = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getRide: function (payload) {
            const self = this;
            const api = self.$store.state.api + "rides/request";

            self.$http
                .post(api, payload)
                .then(() => {
                    this.modalRequestRide = false

                    self.getNextTrips();
                    swal(
                        "Sucesso",
                        "Enviamos seu pedido de carona, fique atento ao seu e-mail, em breve você receberá um retorno!",
                        "success"
                    );
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
        openModalApprove(data) {
            this.dataModalApprove = data;
        },
        changeStatus: function (data) {
            const self = this;
            self.isLoading = true;
            const api = self.$store.state.api + "rides/change-status";

            var dateDpt;
            if (this.dataModalApprove.departure_date != undefined) {
                dateDpt = this.dataModalApprove.departure_date;
            } else {
                dateDpt = null;
            }

            const params = {
                ride_id: data.id,
                departure_date: dateDpt,
                observation: data.requested_observation,
                status: data.status
            }

            self.$http
                .post(api, params)
                .then(() => {
                    this.modalResponsetRide = false;
                    self.getNextTrips();
                    swal(
                        "Sucesso",
                        "Atualizamos a solicitação, avisaremos ao solicitante sobre sua decisão!",
                        "success"
                    );
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                })
                .finally(() => {
                    self.isLoading = false;
                })
        },
        openModalUser(object) {
            var obj = {};
            obj.user = object;
            this.modalUserStatus = true;
            this.dataModalUser = obj;
            this.loadModalUser = true;
        },
        openModalCarona(object) {
            this.dataRideModal = object;
            this.modalRequestRide = true;
        },
        changeUserModal(status) {
            this.modalUserStatus = status;
        },
    },
    mounted: function () {
        const self = this;
        self.getNextTrips();
        self.getCityDestinations();
    },
    components: {ResponseRideModal, RequestRideModal, Loading, Pagination, UserModal, CtkDateTimePicker},
};
</script>
<style scoped></style>

<style>
.uploading-image {
    display: flex;
}

.max {
    width: 60%;
}

.comment {
    margin-top: 15px;
    background-color: #efefef;
    padding: 15px;
}

.h-10 {
    height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NextTrips/Index.vue